import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/raw/gradient.svg'


const _withScopeId = n => (_pushScopeId("data-v-92cf16c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "main-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "background",
  src: _imports_0
}, null, -1))
const _hoisted_3 = { class: "logo" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { id: "title" }, "TRASHABLE", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("START")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Catre site")

import Button from '@/components/ui/Button.vue';
import TrashableLogo from '@/components/icons/TrashableLogo.vue';

import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();

function goToMainScreen() {
	router.push('/main');
}

function goToHomeSite() {
	window.location.href = 'https://trashable.giveitback.ro/';

	// Possible macos fix
	// eslint-disable-next-line no-restricted-globals
	location.href = 'https://trashable.giveitback.ro/';
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(TrashableLogo)
    ]),
    _hoisted_4,
    _createVNode(Button, {
      size: "small",
      id: "start",
      onClick: goToMainScreen
    }, {
      default: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    }),
    _createVNode(Button, {
      size: "normal",
      id: "to-site",
      onClick: goToHomeSite
    }, {
      default: _withCtx(() => [
        _hoisted_6
      ]),
      _: 1
    })
  ]))
}
}

})